<template>
    <div class="messenger-channel-widget">
        <md-button
            ref="buttonRef"
            style="min-width: 20px; max-width: 25px"
            :class="{ [getHealthStatus()]: true }"
            class="actionButtonBreadcrumb m-0 wp-btn messenger-status-button"
            @mouseenter="messengerIconHovered = true"
            @mouseleave="messengerIconHovered = false"
            @click="toggleDropdown"
        >
            <MessengerIcon 
                class="whatsapp-channel-icon" 
                :showGradient="messengerIconHovered || isDropdownVisible"
            />
        </md-button>

        <!-- Custom Dropdown -->
        <div v-if="isDropdownVisible" class="custom-dropdown" :style="dropdownStyle" :class="{ 'dropdown-ready': dropdownReady }">
            <div class="dropdown-content">
                <ChannelStatusItem
                    v-if="filteredMessengerChannels.length > 0"
                    v-for="(channel, index) in filteredMessengerChannels"
                    :key="channel._id"
                    :channel="channel"
                    :whatsapp-modal="false"
                    @close="closeDropdown"
                />
            </div>
        </div>

        <!-- Backdrop to close dropdown -->
        <div v-if="isDropdownVisible" class="dropdown-backdrop" @click="closeDropdown"></div>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ChannelStatusItem from "./ChannelStatusItem.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import MessengerIcon from "../svg/appBreadCrumb/MessengerIcon.vue";

export default {
    name: "MessengerChannelStatusWidget",
    components: { MessengerIcon, ChannelStatusItem },
    data() {
        return {
            messengerIconHovered: false,
            isDropdownVisible: false,
            dropdownStyle: {},
            dropdownReady: false,
        };
    },
    computed: {
        ...mapState({}),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            filteredMessengerChannels: "channel/getVisibleMessengerChannels",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        getColor() {
            const status = this.getHealthStatus();

            if (status === "not-healthy") {
                return "red";
            } else if (status === "partially-healthy") {
                return "#faa566";
            } else {
                return "green";
            }
        },
    },
    methods: {
        updateDropdownPosition() {
            if (!this.$refs.buttonRef) return;
            
            const buttonRect = this.$refs.buttonRef.$el.getBoundingClientRect();
            const dropdownWidth = 300;
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const padding = 16;
            
            let top = buttonRect.bottom + 8;
            let left = buttonRect.left + (buttonRect.width / 2);
            let transform = 'translateX(-50%)';
            
            const wouldOverflowRight = left + (dropdownWidth / 2) > viewportWidth - padding;
            const wouldOverflowLeft = left - (dropdownWidth / 2) < padding;
            
            if (wouldOverflowRight) {
                this.dropdownStyle = {
                    top: `${top}px`,
                    right: `${padding}px`,
                    left: 'auto',
                    transform: 'none',
                };
            } else if (wouldOverflowLeft) {
                this.dropdownStyle = {
                    top: `${top}px`,
                    left: `${padding}px`,
                    right: 'auto',
                    transform: 'none',
                };
            } else {
                this.dropdownStyle = {
                    top: `${top}px`,
                    left: `${left}px`,
                    transform: 'translateX(-50%)',
                };
            }
            
            this.$nextTick(() => {
                const dropdown = this.$el.querySelector('.custom-dropdown');
                if (dropdown) {
                    const dropdownRect = dropdown.getBoundingClientRect();
                    if (dropdownRect.bottom > viewportHeight - padding) {
                        this.dropdownStyle.top = `${buttonRect.top - dropdownRect.height - 8}px`;
                    }
                }
            });
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible;
            if (this.isDropdownVisible) {
                this.dropdownReady = false;
                this.$nextTick(() => {
                    this.updateDropdownPosition();
                    setTimeout(() => {
                        this.dropdownReady = true;
                    }, 10);
                });
            } else {
                this.dropdownReady = false;
            }
        },
        closeDropdown() {
            this.isDropdownVisible = false;
            this.dropdownReady = false;
        },
        getHealthStatus() {
            const channels = [...this.filteredMessengerChannels];
            const isExistsAnyOfflineChannel = false;
            const isAllOffline = false;

            if (isAllOffline) {
                return "not-healthy";
            } else if (isExistsAnyOfflineChannel) {
                return "partially-healthy";
            } else {
                return "healthy";
            }
        },
    },
    mounted() {},
};
</script>
<style lang="scss" scoped>
.messenger-channel-widget {
    position: relative;
    display: inline-block;
}

.md-icon-style {
    color: green;
    font-size: 14px !important;
    display: flex !important;
}

.whatsapp-channel-icon {
    width: 18px !important;
    height: 18px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
        width: 18px !important;
        height: 18px !important;
    }
}

.ant-menu-submenu-arrow {
    position: unset !important;
}

.wp-btn {
    &.partially-healthy {
        //pulse border color animation gray to orange
        border: 1px solid #faa566 !important;
        animation: pulse 2s infinite;
    }
}

.messenger-status-button {
    background: none !important;
    box-shadow: none !important;
    border: none !important;
    
    &:hover,
    &:focus,
    &:active {
        background: none !important;
        box-shadow: none !important;
        border: none !important;
    }
    
    &::before {
        display: none !important;
    }
    
    .md-ripple {
        display: none !important;
    }
}

// Custom Dropdown Styles
.custom-dropdown {
    position: fixed;
    background: #F5F6FA;
    border-radius: 10px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
    z-index: 10000;
    min-width: 280px;
    max-width: 320px;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease-out, visibility 0.15s ease-out;
    
    &.dropdown-ready {
        opacity: 1;
        visibility: visible;
    }

    &::before {
        content: '';
        position: absolute;
        top: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #F5F6FA;
        filter: drop-shadow(0 -2px 3px rgba(0, 0, 0, 0.05));
    }

    .dropdown-content {
        display: flex;
        flex-direction: column;
        max-height: 200px;
        overflow-y: auto;
        padding: 4px;
        pointer-events: auto;

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: #C9BBF6;
            border-radius: 10px;

            &:hover {
                background: #B8A5F0;
            }
        }
    }
}

.dropdown-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: transparent;
    pointer-events: auto;
}

@media (max-width: 768px) {
    .custom-dropdown {
        right: 8px !important;
        left: auto !important;
        transform: none !important;
    }
}
</style>
